module.exports = __webpack_public_path__ + "static/media/upload-success.e4093f8f.png";